import React from 'react';
import * as Yup from 'yup';

import { Field, Form, Formik } from 'formik';

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import CustomTextField from '../../components/TextField';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';

const filterOptions = createFilterOptions({
    matchFrom: 'start',
});

const DialogItineraryLocal = (props) => {
    const { open, handleCancel, handleSave, loading } = props;

    const locations = useSelector((state) => state.line.lineLocations);

    const validationSchema = Yup.object().shape({
        cdLinhaLocalidade: Yup.string().required('Campo obrigatório'),
    });

    const onCancel = (e, reason) => {
        if (reason && reason === 'backdropClick') return;
        if (handleCancel) handleCancel(e);
    };

    return (
        <Dialog disableEscapeKeyDown open={open} onClose={onCancel}>
            <DialogTitle>Selecione nova localidade</DialogTitle>
            <Formik
                enableReinitialize={true}
                initialValues={{ cdLinhaLocalidade: '' }}
                validationSchema={validationSchema}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={() => {}}>
                {(formProps) => {
                    return (
                        <Form>
                            <DialogContent style={{ paddingTop: '0px', maxWidth: '350px' }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Field
                                            component={CustomTextField}
                                            label="Localidade"
                                            name="cdLinhaLocalidade"
                                            select
                                            size="small"
                                            margin="dense">
                                            {({ form: { errors, setFieldValue } }) => {
                                                return (
                                                    <Autocomplete
                                                        id="combo-box-demo"
                                                        options={locations}
                                                        filterOptions={filterOptions}
                                                        getOptionLabel={(option) => option.deNome}
                                                        style={{ width: 300 }}
                                                        onChange={(e, value) =>
                                                            setFieldValue(
                                                                'cdLinhaLocalidade',
                                                                value?.cdLinhaLocalidade || '',
                                                            )
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                label="Localidade"
                                                                variant="filled"
                                                                error={!!errors.cdLinhaLocalidade}
                                                                helperText={
                                                                    errors.cdLinhaLocalidade
                                                                        ? errors.cdLinhaLocalidade
                                                                        : ''
                                                                }
                                                            />
                                                        )}
                                                    />
                                                );
                                            }}
                                        </Field>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                {loading ? (
                                    <>
                                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                                            <CircularProgress size={12} />
                                        </Grid>
                                    </>
                                ) : (
                                    <>
                                        <Button onClick={() => handleCancel()} color="primary">
                                            Cancelar
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                formProps.validateForm().then((res) => {
                                                    if (Object.keys(res).length <= 0) {
                                                        handleSave(formProps.values);
                                                    }
                                                });
                                            }}
                                            color="primary">
                                            Salvar
                                        </Button>
                                    </>
                                )}
                            </DialogActions>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    );
};

export default DialogItineraryLocal;
